export default __webpack_public_path__ + "static/media/hero.c98cb319.svg";